import Training from "./Training.jsx";
export default Training